// import { createMuiTheme } from '@mui/material/styles';
// import { amber } from '@mui/material/colors';

import { createTheme } from '@mui/material/styles';
import { purple, deepPurple, blueGrey, blue } from '@mui/material/colors';


const theme = createTheme({
  
  palette: {
    primary: {
        main: blueGrey[900],
        dark: blueGrey[500],
        light: blueGrey[50],
    },
    secondary: {
      main: '#f44336',
    },
    pink: {
      deep: '#FF1493',
      hot: '#FF69B4',
      medium: '#C71585',
      pale: '#DB7093',
      light: '#FFB6C1',
      text: '#e3f2fd',
    },
    
  },
});

// const theme = createTheme({
//     palette: {
//         primary: pink[500],
//         secondary:lightBlue,
//         direction: 'rtl',
//       },
//   });


// const theme = createMuiTheme({
//     palette:{
//         primary:amber
//     }
// });

export default theme